<template>
  <div>
    <div class="product-type">
    <section class="for-outgoing">
      <div class="product-header">
        <span>たくさんの人に</span><br />
        <span class="header-bold">コールしたい!!</span>
      </div>
      <ul class="product-items">
        <li v-for="(item, index) in outgoingItems" :key="index">
          <product-item-appeal
            v-bind:name="item.name"
            v-bind:productName="item.productName"
            v-bind:subtitle="item.subtitle"
            v-bind:title="item.title"
            v-bind:appeal="item.appeal"
            v-bind:detail="item.detail"
            v-bind:recommends="item.recommends"
          />
        </li>
      </ul>
    </section>

    <section class="for-incoming">
      <div class="product-header">
        <span>たくさんの人や設置場所から</span><br />
        <span class="header-bold">コールを受けたい!!</span>
      </div>
      <ul class="product-items">
        <li v-for="(item, index) in incomingItems" :key="index">
          <product-item-appeal
            v-bind:name="item.name"
            v-bind:productName="item.productName"
            v-bind:subtitle="item.subtitle"
            v-bind:title="item.title"
            v-bind:appeal="item.appeal"
            v-bind:detail="item.detail"
            v-bind:recommends="item.recommends"
          />
        </li>
      </ul>
    </section>
    </div>

    <div class="product-list-button-wrap">
      <router-link to="/products" class="product-list-button">
        商品一覧を確認する
      </router-link>
    </div>
  </div>
</template>

<script>
import ProductItemAppeal from '@/components/modules/ProductItemAppeal'

export default {
  components: {
    ProductItemAppeal,
  },
  data() {
    return {
      outgoingItems: [
        {
          name: 'remote-reply-call',
          productName: 'リモートリプライコール',
          subtitle: 'コードレスパーソナルコールシステム',
          title: '数キロ先の長距離範囲を呼び出したい',
          appeal:
            '長距離通信を実現！32文字のメッセージで確実に知らせる！受信状況も画面で確認できる！',
          detail: `32文字までのメッセージを
          送信できます。`,
          recommends: [
            '順番待ちのお客様が離れた場所にいても確実に呼び出したい方',
            '大型施設や総合病院など、広い施設で遠くにいるお客様を呼び出したい方',
            '呼び出し時にメッセージを表示させて、誘導ツールとして活用したい施設',
          ],
        },
        {
          name: 'remote-reply-call-pc',
          productName: 'リモートリプライコールPC',
          subtitle: 'コードレスパーソナルコールシステム',
          title: '数キロ先の長距離範囲をパソコンから呼び出したい',
          appeal:
            'リモートリプライコールをマウス / タッチパネルの簡単操作で利用することができます！',
          detail: `わかりやすいアイコン表示で、
          お知らせ漏れの心配が
          ありません。`,
          recommends: [
            'パソコンから簡単操作でお客様を呼び出し、呼出状況を画面で確認したい施設',
            '多数の受信機（最大999台）を呼び出し、独自メッセージ送信したい施設・現場',
            '自社の既存システムと連携させて、自動で呼出し送信したい企業・施設',
          ],
        },
        {
          name: 'reply-call',
          productName: 'リプライコール',
          subtitle: 'コードレスパーソナルコールシステム',
          title: '順番や時間が来たら呼び出したい',
          appeal:
            'LED・ブザー音・バイブレーションなどでお客様をスマートにお呼び出し。トラブルもしっかり予防 !',
          detail: `AC電源はもちろん
          電池駆動で屋外でも
          活用可能。`,
          recommends: [
            'フードコートや飲食店などでお客様をスムーズに呼び出したい店舗',
            '屋内・屋外のどちらでも使える呼び出しシステムを探している方',
            '呼び出しが届いているかを確認でき、安心して運用できるシステムを導入したい施設',
          ],
        },
        {
          name: 'reply-call-pc',
          productName: 'リプライコール PC',
          subtitle: 'コードレスパーソナルコールシステム',
          title: 'パソコンから呼び出したい',
          appeal: `リプライコールをパソコンやタブレットから
            操作することができます。`,
          detail: `PC/ タブレットから
          登録コードを
          ワンタッチで送信。`,
          recommends: [
            'パソコンから簡単操作でお客様を呼び出し、通信履歴を画面で確認したい施設',
            '多数の受信機（最大500台）を呼び出し、独自コード送信したい施設・現場',
            '呼出コードを表示させて、呼ばれている場所を知らせたい施設',
          ],
        },
      ],
      incomingItems: [
        {
          name: 'beyond-ec',
          productName: 'ビヨンドイーシー',
          subtitle: '新・呼び出しシステム',
          title: 'より機能的で、より便利に連絡を受けたい',
          appeal: `お手持ちのスマホがそのままレシーバーとして利用できる
            Wi-Fi を利用した「新・呼び出しシステム」！`,
          detail: `Android スマホが
          そのままレシーバーに︕`,
          recommends: [
            'Wi-Fiを利用してスマートフォンを受信機として使いたい企業・店舗',
            '呼出情報を液晶モニターに表示できるシステムを探している企業・現場',
            '「Wi-Fi」「Slack」「VPN」多様な通信方式から、運用スタイルを選びたい施設',
          ],
        },
        {
          name: 'eco-chime',
          productName: 'エコチャイム',
          subtitle: 'コードレスコールシステム',
          title: 'お客様からの注文や呼び出しの連絡を受け取りたい',
          appeal: `元祖！電池レス呼び出しチャイム。
            電池交換不要でエコ＆トラブル減少を実現！`,
          detail: `電池を使わない
          革新的なチャイム。`,
          recommends: [
            '電池交換不要でトラブルやコストを減らしたい店舗',
            '水や汚れが多い厨房など、丸洗いできる清潔な呼び出しベルを使いたい飲食店',
            'シンプルで故障が少ない、メンテナンス性の高いシステムを求める施設',
          ],
        },
        {
          name: 'coco-call',
          productName: 'コココール',
          subtitle: 'コードレスコールシステム',
          title: 'お客様からの注文や会計の連絡を受け取りたい',
          appeal: `送信機ごとにチャイム音が設定できる！
            使い勝手の良さと豊富なデザインが魅力のコココール。`,
          detail: `送信機ごとに
          チャイム音を設定！
          防沫構造で水洗いも可能。`,
          recommends: [
            'テーブルからスタッフを呼び出す飲食店・居酒屋・カフェ',
            '携帯受信表示機で離れた場所や移動中に呼び出しを受けたい施設',
            '急ぎの呼び出しが解り、対応遅れを防ぎ、対応スピードを向上させたい店舗',
          ],
        },
        {
          name: 'fact-in-call',
          productName: 'ファクトインコール',
          subtitle: 'コードレスパーソナルコールシステム',
          title: '工場や倉庫内のトラブル時に連絡をすぐに受けたい',
          appeal: `急なトラブルや呼び出しを逃さない！
            工場、飲食店、病院などで活躍するコールシステム！`,
          detail: `工場ラインの安定稼働
          大幅な省力化を実現。`,
          recommends: [
            'トラブル別に表示色を設定して呼び出しを色分け表示したい現場',
            '広い工場や倉庫で離れた場所や移動中の作業員をに呼び出したい製造現場',
            'トラブル発生の回数や時間帯等をデータ管理したい工場',
          ],
        },
      ],
    }
  },
}
</script>

<style scoped>
.product-image {
  display: inline-block;

  width: auto;
  height: 200px;
  margin: 30px 0 10px 0;
}

.for-outgoing,
.for-incoming {
  margin: 0;
}

.product-image {
  width: 70%;
  max-width: 400px;
  height: auto;
  margin: 30px auto 10px auto;
}

.product-item-appeal {
  width: 90%;
  margin: 0 auto;
}

.header-bold {
  font-size: 30px;
}

.product-type {
  flex-direction: column;
}

.product-header {
  float: none;

  width: 100%;
  padding: 0;
}

.product-items {
  float: none;

  width: auto;
  padding: 0;
}

.product-items li + li {
  margin-top: 10px;
  padding-top: 30px;

  border-top: 2px solid rgba(0, 0, 0, 0.15);
}

.product-list-button-wrap {
  display: flex;
  justify-content: center;

  margin-top: 30px;
  padding: 0 5% 30px;
}

.product-list-button {
  font-size: 18px;
  font-weight: bold;

  display: block;

  width: 100%;
  max-width: 320px;
  padding: 14px 10px;

  text-align: center;
  text-decoration: none;
  letter-spacing: 1px;

  color: #ffffff;
  border-radius: 6px;
  border-bottom: 4px solid rgb(15, 58, 120);
  background-color: rgb(26, 87, 167);
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2);

  transition: opacity 0.3s;
}

.product-list-button:hover {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/choice/SpChoiceByPurpose.vue